module.exports = __webpack_public_path__ + "img/poti_mai_mult.a58ff921.png";